import type {DropzoneErrorState} from "./types.ts";
import {reactive, ref} from "vue";

export default class Provider {
    public refs = {
        semaphore: ref(0),
        dropzoneErrorState: reactive<DropzoneErrorState>({
            hasUploadError: false,
        }),
    }
}
